import { Children, cloneElement } from 'react';

import { usePopoverContext } from './context';

import type { FC, ReactElement } from 'react';

export interface ToggleProps {
  children: ReactElement[];
}

export const PopoverHoverEnter: FC<ToggleProps> = ({ children, ...props }) => {
  const { handleOpen } = usePopoverContext();

  return (
    <>
      {Children.map(children, (child) =>
        cloneElement(child, {
          onMouseEnter: handleOpen,
          ...props,
        })
      )}
    </>
  );
};
